import { State } from 'src/types'
import { hamidashiOfNormal } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/ringFinger'
import { indexFingerLeft, indexFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/indexFinger'
import { littleFingerLeft, littleFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/littleFinger'
import { thumbAndWristBeltForErmWrist, thumbOut } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/thumbAndWristBelt'
import { listBelt } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/listBelt'
import { indexFingerPad } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCrotch'
import { catchFace2 } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/catchFace2'
import { edgeOfBeltBackStyle } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/edge/edgeOfBeltBackstyle'
import { edgeOfErmWrist, edgeOfWrist } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/edge/edgeOfWrist'
import { middleFingerPad } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCoverOrPad/middleFIngerPad'
import { seriesChecker } from 'src/features/atoms/glove/simulationSpecification'
import { ermBelt } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/ermBelt'
import { middleFingerCover } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCoverOrPad/middleFingerCover'

// 通常ベルトモデル
export const beltBackStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): Promise<void> => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerCover = ['middleCover'].includes(state.fingerGuardType?.value)
  const { is2025Agl, is2025Apl, isDefaultWristBelt } = seriesChecker(state.baseModel.productNumber)
  const stitchColor = state.stitch.color
  const bindingColor = state.edge.color
  const printLeatherTypeValue = state.printLeatherType?.value

  await thumbAndWristBeltForErmWrist(ctx, state.thumbWeb?.color, printLeatherTypeValue)
  await thumbOut(ctx, state.thumbOut?.color, printLeatherTypeValue) // 親指＿外
  await indexFingerRight(ctx, state, needCatchFaceWrap, printLeatherTypeValue) // UBackここで描いてる
  if (isDefaultWristBelt) {
    await listBelt(ctx, state.listBelt?.color, stitchColor, printLeatherTypeValue)
  } else if (is2025Apl && !is2025Agl) {
    await ermBelt(ctx, state.listBelt.color, stitchColor, printLeatherTypeValue)
  }

  await indexFingerLeft(ctx, state.indexMiddle?.color, printLeatherTypeValue) // 人差し指＿左
  await middleFingerRight(ctx, state.middleIndex?.color, printLeatherTypeValue) // 中指＿右
  await middleFingerLeft(ctx, state.middleRing?.color, printLeatherTypeValue) // 中指＿左
  await ringFingerRight(ctx, state.ringMiddle?.color, printLeatherTypeValue) // 薬指＿右
  await ringFingerLeft(ctx, state.ringLittle?.color, printLeatherTypeValue) // 薬指＿左
  await littleFingerRight(ctx, state.littleRing?.color, printLeatherTypeValue) // 小指
  await littleFingerLeft(ctx, state.littleOut?.color, printLeatherTypeValue) // 小指
  hamidashiOfNormal(ctx, state.hamidashi?.color)

  catchFace2(ctx, state.catchFace?.color, stitchColor, needCatchFaceWrap) // 捕球面 / ウェブ下折り返し
  edgeOfBeltBackStyle(ctx, bindingColor, stitchColor) // ヘリ革
  if (isDefaultWristBelt) {
    // 投手用 && AGL
    edgeOfWrist(ctx, bindingColor, stitchColor) // これ変える
  } else {
    edgeOfErmWrist(ctx, bindingColor, stitchColor) // これ変える
  }

  // 指当て(人指し指)
  if (isIndexFingerPad) {
    await indexFingerPad(ctx, state.indexCover.color, stitchColor, printLeatherTypeValue)
  }
  // 指当て(中指)
  if (isMiddleFingerPad) {
    await middleFingerPad(ctx, state.indexCover.color, stitchColor, -165, 90, -15, printLeatherTypeValue)
  }
  // 指股
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)
  if (isMiddleFingerCover) {
    await middleFingerCover(ctx, state.indexCover.color, stitchColor, -165, 90, -15, printLeatherTypeValue)
  }
}
